<style lang="less" scoped>
.usersitorget {
	padding: 1rem;
	background: #fff;
	width: 100%;
	border-top: 0.3rem solid #07b446;
	box-sizing: border-box;
	border-radius: 2px;
	color: #333;
	font-size: 0.8rem;

	/deep/ .el-radio__input.is-checked .el-radio__inner {
		border-color: #07b446;
		background: #07b446;
	}

	/deep/ .el-radio__input.is-checked + .el-radio__label {
		color: #333;
	}

	.itorgettitle {
		padding: 0 0 1rem 0;
		font-size: 1.2rem;
		margin-bottom: 1rem;
		border-bottom: 1px solid #ccc;
		color: #07b446;

		span.el-icon-user-solid {
			font-size: 1.4rem;
			vertical-align: middle;
		}
	}

	label.sex {
		justify-content: flex-start;
	}

	label {
		width: 80%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: ;
		margin: 1rem auto;

		/deep/ .form-control {
			color: #000;
			font-weight: 400;
			font-family: 'Microsoft YaHei';
		}

		p {
			text-align: center;
		}
	}

	.passwords {
		margin-left: 23.6%;
		margin-bottom: 0.2rem;
	}

	.appends {
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 2rem 0;

		button {
			border: 1px solid;
			margin-right: 1rem;
			padding: 0.5rem 0.5rem 0.5rem 0.1rem;
			width: 7rem;
			background: #07b446;
			color: #fff;
			border-radius: 5px;
			font-size: 0.8rem;

			i {
				margin-right: 0.4rem;
				font-weight: 700;
			}
		}

		button:last-child {
			background: #fe8930;
		}
	}
}

.form-check {
	display: flex;
	align-items: center;
	margin: 1rem 0;

	label {
		margin: 0 0 0 0.4rem;
	}
}

.must {
	color: red;
	font-size: 1.2rem;
	font-weight: 800;
	margin-left: 0.4rem;
	position: relative;
}

.el-fade-in-linear-enter-active,
.el-fade-in-linear-leave-active {
	transition: opacity 1000ms linear;
}

.el-fade-in-linear-enter,
.el-fade-in-linear-leave,
.el-fade-in-linear-leave-active {
	opacity: 0;
}
</style>
<template>
	<div>
		<titles titlename="添加新用户" titlecontent="这里是新用户注册的地方" :mbx="paths"></titles>
		<div class="usersitorget">
			<p class="itorgettitle">
				<span class="el-icon-s-custom"></span>
				<span class="itorget">用户注册</span>
			</p>
			<form>
				<label>
					<p class="col-xs-2 col-sm-2 col-md-2 col-lg-2" style="position: relative;">用户名：</p>
					<input v-model="usersr.ui_userName" class="form-control" type="text" placeholder="输入用户名" />
					<span class="must">*</span>
				</label>
				<label>
					<p class="col-xs-2 col-sm-2 col-md-2 col-lg-2">真实姓名：</p>
					<input v-model="usersr.ui_realName" class="form-control" type="text" placeholder="输入真实姓名" />
					<span class="must" style="color: #fff;">*</span>
				</label>
				<label class="sex">
					<p class="col-xs-2 col-sm-2 col-md-2 col-lg-2">性别：</p>
					<div style="display: flex;align-items: center;">
						<el-radio v-model="radio" label="1">男</el-radio>
						&nbsp;&nbsp;&nbsp;&nbsp;
						<el-radio v-model="radio" label="2">女</el-radio>
					</div>
				</label>
				<!-- <label>
					<p class="col-xs-2 col-sm-2 col-md-2 col-lg-2">用户类型：</p>
					<select v-model="usersr.ut_guid" class="form-control" id="exampleFormControlSelect1">
						<option value=""> -- 请选择用户类型 --</option>
						<option v-for="(item,index) in typelist" :key="index" :label="item.ut_typeName"
							:value="item.ut_guid">
							{{item.ut_typeName}}
						</option>
					</select>
					<span class="must">*</span>
				</label> -->
				<label>
					<p class="col-xs-2 col-sm-2 col-md-2 col-lg-2">所属省份：</p>
					<select @change="changeschooldiz()" v-model="usersr.AI_ProvinceId" class="form-control" id="exampleFormControlSelect1">
						<option value="">-- 请选择所属省份 --</option>
						<option v-for="(item, index) in schooldiz" :key="index" :label="item.si_name_cn" :value="item.Id">{{ item.Name }}</option>
					</select>
					<span class="must">*</span>
				</label>
				<label>
					<p class="col-xs-2 col-sm-2 col-md-2 col-lg-2">所属院校：</p>
					<select @change="changeschool()" v-model="usersr.si_guid" class="form-control" id="exampleFormControlSelect1">
						<option value="">-- 请选择所属院校 --</option>
						<option v-for="(item, index) in schoollist" :key="index" :label="item.si_name_cn" :value="item.si_guid">{{ item.si_name_cn }}</option>
					</select>
					<span class="must">*</span>
				</label>
				<label>
					<p class="col-xs-2 col-sm-2 col-md-2 col-lg-2">所属专业：</p>
					<select @change="changeclassgetzy()" v-model="usersr.pro_guid" class="form-control" id="exampleFormControlSelect1">
						<option value="">-- 请选择专业 --</option>
						<option v-for="(item, index) in classzylist" :key="index" :label="item.pro_name" :value="item.pro_guid">{{ item.pro_name }}</option>
					</select>
					<span class="must" style="color: #fff;">*</span>
				</label>
				<label>
					<p class="col-xs-2 col-sm-2 col-md-2 col-lg-2">所属班级：</p>
					<select v-model="usersr.cla_guid" class="form-control" id="exampleFormControlSelect1">
						<option value="">-- 请选择班级 --</option>
						<option v-for="(item, index) in classlist" :key="index" :label="item.cla_name" :value="item.cla_guid">{{ item.cla_name }}</option>
					</select>
					<span class="must" style="color: #fff;">*</span>
				</label>

				<label>
					<p class="col-xs-2 col-sm-2 col-md-2 col-lg-2">手机号码：</p>
					<input v-model="usersr.ui_mobile" class="form-control" type="tel" placeholder="输入手机号码" maxlength="11" />
					<span class="must" style="color: #fff;">*</span>
				</label>
				<label>
					<p class="col-xs-2 col-sm-2 col-md-2 col-lg-2">邮箱地址：</p>
					<input v-model="usersr.ui_email" class="form-control" type="email" placeholder="输入真实邮箱地址" />
					<span class="must" style="color: #fff;">*</span>
				</label>
				<transition name="el-fade-in-linear">
					<label v-if="!passds">
						<p class="col-xs-2 col-sm-2 col-md-2 col-lg-2">用户密码：</p>
						<input v-model="usersr.ui_password1" class="form-control" type="password" placeholder="输入用户密码" :readonly="passds" />
						<span class="must">*</span>
					</label>
				</transition>
				<transition name="el-fade-in-linear">
					<label v-if="!passds">
						<p class="col-xs-2 col-sm-2 col-md-2 col-lg-2">再次输入密码：</p>
						<input v-model="usersr.ui_password2" class="form-control" type="password" placeholder="输入用户密码" :readonly="passds" />
						<span class="must">*</span>
					</label>
				</transition>
			</form>
			<div class="passwords">
				<div class="form-check form-check-inline">
					<input class="form-check-input" type="checkbox" id="inlineCheckbox1" v-model="passds" />
					<label class="form-check-label" for="inlineCheckbox1">使用默认密码123456</label>
				</div>
			</div>
			<div class="appends">
				<button type="button" @click="addusersrs()" v-preventReClick>
					<i class="icon-user-follow"></i>
					添加用户
				</button>
				<button type="button" @click="caback()" v-preventReClick>
					<i class="el-icon-refresh-right"></i>
					重置
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import { userRegisterV2 } from '@/request/api/home.js';
import { GetyyGetClassList } from '@/request/api/dataorder/dataprder.js';
import {
	GetbjGetSchoolList, //院校不分页
	GetUserTypeList,
	GetzyProfList,
	GetProfListByclassid,
	GetProvinceListSchool,
	GetRegSchoolListSchool,
	GetProClassList
} from '@/request/api/mange/mange.js';
import { setUploadAvatar } from '@/request/api/userapi/studenthome.js';

export default {
	data() {
		return {
			// 院校地址
			schooldiz: [],
			// 用户信息
			usersr: {
				ut_guid: '',
				cla_guid: '',
				si_guid: '',
				pro_guid: '',
				AI_ProvinceId: ''
			},
			// 表单数据
			radio: '1',
			passds: true,
			option1: 0,
			// 标题
			paths: [
				{
					path: '/basicmanage/manage',
					name: '用户管理'
				},
				{
					path: '/basicmanage/appenduser',
					name: '添加新用户'
				}
			],
			// 班级院校类型
			schoollist: [],
			classlist: [],
			typelist: [],
			classzylist: []
		};
	},
	beforeMount() {
		this.gettypelist();
		GetProvinceListSchool().then(res => {
			this.schooldiz = res.data.data;
		});
	},
	methods: {
		changeschooldiz() {
			this.usersr.si_guid = '';
			this.schoollist = [];
			this.usersr.pro_guid = '';
			this.usersr.cla_guid = '';
			this.classzylist = [];
			this.classlist = [];
			if (this.usersr.AI_ProvinceId != '') {
				GetRegSchoolListSchool(this.usersr.AI_ProvinceId).then(res => {
					this.schoollist = res.data.data;
				});
			}
		},

		// 更改专业获取班级
		changeclassgetzy() {
			// let zygetobj = {
			// 	si_guid: this.usersr.si_guid,
			// 	cla_guid: this.usersr.cla_guid
			// }
			this.usersr.cla_guid = '';
			this.classlist = [];
			if (this.usersr.pro_guid != '') {
				GetProClassList(this.usersr.pro_guid).then(res => {
					this.classlist = res.data.data;
				});
			}
		},
		caback() {
			this.usersr = {};
			this.usersr.si_guid = '';
			this.usersr.cla_guid = '';
			this.usersr.ut_guid = '';
			this.usersr.AI_ProvinceId = '';
			this.usersr.pro_guid = '';
		},
		// 院校班级类型专业
		getschoollist() {
			GetbjGetSchoolList().then(res => {
				// console.log(res)
				this.schoollist = res.data.data;
			});
		},
		getsclasslist(guid) {
			GetzyProfList(guid).then(res => {
				this.classzylist = res.data.data;
			});

			// GetyyGetClassList(guid).then(res => {
			// 	this.classlist = res.data.data
			// })
		},
		gettypelist() {
			GetUserTypeList().then(res => {
				// console.log(res)
				this.typelist = res.data.data;
			});
		},
		getclasszylist(guid) {
			GetProfListByclassid(guid).then(res => {
				// console.log(res, '专业不分页')
				this.classzylist = res.data.data;
			});
		},

		//更改院校专业更改
		changeschool() {
			if (this.usersr.si_guid == '') {
				this.usersr.pro_guid = '';
				this.classzylist = [];
			} else {
				this.getsclasslist(this.usersr.si_guid);
			}
		},
		// 添加用户
		addusersrs() {
			let userobj = {
				ui_userName: this.usersr.ui_userName,
				ui_password1: this.passds ? '123456' : this.usersr.ui_password1,
				ui_password2: this.passds ? '123456' : this.usersr.ui_password2,
				ui_email: this.usersr.ui_email,
				ui_realName: this.usersr.ui_realName,
				ui_sex: this.radio,
				si_guid: this.usersr.si_guid,
				ut_guid: this.usersr.ut_guid,
				cla_guid: this.usersr.cla_guid,
				ui_mobile: this.usersr.ui_mobile
			};
			if (this.usersr.ui_userName == undefined) {
				this.$message('用户名不能为空');
			}

			/* 
			 if (this.usersr.AI_ProvinceId == '') {
			 	this.$message('省份不能为空');
			 } else if (this.usersr.si_guid == '') {
			 	this.$message('院校不能为空');
			 } */

			userRegisterV2(userobj).then(res => {
				// console.log(res)
				if (res.data.code == 1) {
					this.$message({
						message: '恭喜你，' + res.data.msg,
						type: 'success'
					});
					this.usersr = {};
					this.usersr.si_guid = '';
					this.usersr.cla_guid = '';
					this.usersr.ut_guid = '';
					this.usersr.pro_guid = '';
					this.usersr.AI_ProvinceId = '';
				} else {
					this.$message(res.data.msg);
				}
			});
		}
	},
	components: {
		titles
	}
};
</script>

<style></style>
